import * as React from 'react';
import styled from 'styled-components';
import {COLORS, focusStyles} from '../styles';
import { Size, Testable } from '../types';
import { SystemIcons } from '../icons';
import { ComponentTextStyle, ComponentSStyling, ComponentXSStyling } from '../styles';
import {defaultOnMouseDownHandler} from '../common';

export const BackButtonContentContainer = styled.div``;

const BackButtonContainerStyles = styled.button<{$size: Size, dataTestId: string | undefined}>`
  box-sizing: border-box;
  min-height: 48px;
  padding: 0;
  margin: 0;
  outline:none;
  max-width: max-content;
  display: flex;
  align-items: center;
  border: none;
  background-color: transparent;
  cursor: pointer;

  ${(props) => (props.$size === Size.XSmall ? ComponentXSStyling(ComponentTextStyle.Bold, COLORS.generateToken({ componentType: 'text', defaultVariant: 'subtle' }, props.theme)) 
    : ComponentSStyling(ComponentTextStyle.Bold, COLORS.generateToken({ componentType: 'text', defaultVariant: 'subtle' }, props.theme)))};
  font-feature-settings: 'liga' off;

  & > ${BackButtonContentContainer} {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    max-width: max-content;
    padding: 4px 4px 4px 0;
    border-radius: 4px;
    cursor: inherit;
    min-width: 64px;

  }

  & > ${BackButtonContentContainer} > span {
    display: flex;
    cursor: inherit;
  }
  & > ${BackButtonContentContainer} > label {
    display: flex;
    cursor: inherit;
    flex-grow: 1;
    justify-content: center;
  }

  &:hover > ${BackButtonContentContainer},
  &.hover-state > ${BackButtonContentContainer} {
    background-color: ${props => COLORS.generateToken({ componentType: 'bg-surface', state: 'hover' }, props.theme)};
    color: ${props => COLORS.generateToken({ componentType: 'text', state: 'hover' }, props.theme)};
  }
  &:focus > ${BackButtonContentContainer},
  &.focus-state > ${BackButtonContentContainer} {
    ${focusStyles}
  }
  &:active > ${BackButtonContentContainer},
  &.active-state > ${BackButtonContentContainer} {
    background-color: ${props => COLORS.generateToken({ componentType: 'bg-surface', state: 'active' }, props.theme)};
    color: ${props => COLORS.generateToken({ componentType: 'text', state: 'active' }, props.theme)};
  }
  &:disabled {
    cursor: not-allowed;
  }
  &:disabled > ${BackButtonContentContainer} {
    color: ${props => COLORS.generateToken({ componentType: 'text', state: 'disabled' }, props.theme)} !important;
    background-color: transparent !important;
  }
`;

export interface BackButtonProps extends Testable, React.ButtonHTMLAttributes<HTMLButtonElement> {
    /**
   * Required. The size of the back button. Can be 'Small' or 'XSmall'.
   */
  size: Size.Small | Size.XSmall;
    /**
   * Optional. A boolean indicating whether the back button is disabled.
   */
  disabled?: boolean;
}
const BackButton: React.FunctionComponent<BackButtonProps> = ({ children, size: size = Size.Small, dataTestId, ...props }) => {
  return (
    <BackButtonContainerStyles {...props} $size={size} onMouseDown={defaultOnMouseDownHandler} dataTestId={dataTestId}>
      <BackButtonContentContainer>
        <span aria-hidden="true">
          <SystemIcons.ArrowLineLeft size={size === Size.XSmall ? '20' : '24'} />
        </span>
        <label>{children}</label>
      </BackButtonContentContainer>
    </BackButtonContainerStyles>
  );
};

export default BackButton;
